// Copyright (c) 2017 VMware, Inc. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { NgModule } from '@angular/core';
import { AuditLogComponent } from './audit-log.component';
import { SharedModule } from '../shared/shared.module';
import { AuditLogService } from './audit-log.service';
import { RecentLogComponent } from './recent-log.component';

@NgModule({
  imports: [SharedModule],
  declarations: [
    AuditLogComponent,
    RecentLogComponent],
  providers: [AuditLogService],
  exports: [
    AuditLogComponent,
    RecentLogComponent]
})
export class LogModule { }


// WEBPACK FOOTER //
// ./src/app/log/log.module.ts